<template lang="pug">
.map-container.relative(:class="{ show: showMap }")
    slot
    //- :zoom="calculatedZoom"
    //- :center="center"
    MglMap(
        ref="mapbox"
        :accessToken="mapboxKey"
        :map-style="style"
        :max-zoom="18"
        :min-zoom="2.5"
        :interactive="true"
        @load="loaded"
    )
        MglMarker(
            :coordinates="center"
            :color="color"
            anchor="bottom"
        )
            // i.fa-map-marker-alt.fas(slot="marker" :style="{ color }")
            //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M311.3 267.4c-16.4 32.2-38.8 66.4-62.1 98.3c-20.3 27.9-40.7 53.3-57.2 73.1c-16.5-19.8-36.9-45.2-57.2-73.1c-23.2-31.9-45.6-66.2-62.1-98.3C55.7 234 48 208.3 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 16.3-7.7 42-24.7 75.4zM223.8 475.6C278.4 411 384 275.1 384 192C384 86 298 0 192 0S0 86 0 192c0 83.1 105.6 219 160.2 283.6C179.2 498.1 192 512 192 512s12.8-13.9 31.8-36.4z"/></svg>
            .marker.center(slot="marker")
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"/></svg>

        //- template(v-if="combinedAddresses && combinedAddresses.length")
        //-     MglMarker(
        //-         v-for="address in combinedAddresses" :key="address.id"
        //-         :coordinates="[address.longitude, address.latitude]"
        //-         :color="color"
        //-         anchor="bottom"
        //-     )
        //-         // i.fa-map-marker-alt.fas(slot="marker" :style="{ color }")
        //-         //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M384 192c0 112-192 320-192 320S0 304 0 192C0 86 86 0 192 0S384 86 384 192z"/></svg>
        //-         //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>
        //-         .marker.address(slot="marker")
        //-             //- <svg v-if="addressIsVisible(address)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>
        //-             //- <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M311.3 267.4c-16.4 32.2-38.8 66.4-62.1 98.3c-20.3 27.9-40.7 53.3-57.2 73.1c-16.5-19.8-36.9-45.2-57.2-73.1c-23.2-31.9-45.6-66.2-62.1-98.3C55.7 234 48 208.3 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 16.3-7.7 42-24.7 75.4zM223.8 475.6C278.4 411 384 275.1 384 192C384 86 298 0 192 0S0 86 0 192c0 83.1 105.6 219 160.2 283.6C179.2 498.1 192 512 192 512s12.8-13.9 31.8-36.4z"/></svg>
        //-             //- <svg v-if="addressIsVisible(address)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M311.3 267.4c-16.4 32.2-38.8 66.4-62.1 98.3c-20.3 27.9-40.7 53.3-57.2 73.1c-16.5-19.8-36.9-45.2-57.2-73.1c-23.2-31.9-45.6-66.2-62.1-98.3C55.7 234 48 208.3 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 16.3-7.7 42-24.7 75.4zM223.8 475.6C278.4 411 384 275.1 384 192C384 86 298 0 192 0S0 86 0 192c0 83.1 105.6 219 160.2 283.6C179.2 498.1 192 512 192 512s12.8-13.9 31.8-36.4z"/></svg>
        //-             .dot(:class="{ solid: addressIsVisible(address) }")
</template>

<script>
import Mapbox from 'mapbox-gl';
import { mapGetters } from 'vuex';

import MultiTouch from 'mapbox-gl-multitouch';
import { MglMap, MglMarker } from 'vue-mapbox';

// import PinOutlined from '@/assets/svgs/pin-outlined.svg';
import circleOutlined from '@/assets/svgs/circle-outlined.svg';
import circleSolid from '@/assets/svgs/circle-solid.svg';

export default {
    name: 'MapBox',
    data() {
        return {
            style: 'mapbox://styles/vanameland/ckclxo9az13jn1io5gnwr9tjr',
            color: '#be1521',
            // center: [10.4515, 51.1657], // germany: [10.4515, 51.1657]
            zoom: 2.5,
            showMap: false
        };
    },
    props: {
        addresses: {
            type: Array,
            required: false
        },
        visibleAddresses: {
            type: Array,
            required: false
        },
        center: {
            type: Array,
            required: true
        }
    },
    components: {
        MglMap,
        MglMarker
    },
    watch: {
        addresses() {
            this.$nextTick(() => {
                this.updateMarkers();
            });
        },
        visibleAddresses() {
            this.$nextTick(() => {
                // this.$refs.mapbox.map.resize();
                this.updateMapBoxCenter(1000);
                this.updateMarkers();
            });
        },
        center() {
            this.$nextTick(() => {
                // this.$refs.mapbox.map.resize();
                // this.updateMapBoxCenter(1000);
                // this.updateMarkers(1300);
            });
        }
    },
    computed: {
        // combinedAddresses() {
        //     const addresses = [...this.addresses || [], ...this.visibleAddresses || []]
        //     return addresses.filter((el, i) => {
        //         return el && el.latitude && el.longitude && addresses.findIndex(address => address.id === el.id) >= i;
        //     });
        // },
        ...mapGetters({
            mapboxKey: 'mapboxKey'
        })
    },
    methods: {
        async updateMarkers(delay = 0) {
            if (!this.addresses || !this.addresses.length) return;
            if (!this.$refs.mapbox || !this.$refs.mapbox.map) {
                await new Promise(resolve => setTimeout(resolve, 100));
                return this.updateMarkers(delay);
            }

            const addresses = {
                type: 'FeatureCollection',
                features: []
            };

            addresses.features = this.addresses
                .map(address => {
                    if (
                        address.latitude &&
                        address.longitude &&
                        !this.visibleAddresses.some(el => el.id === address.id)
                    ) {
                        // if (address.latitude && address.longitude) {
                        return {
                            type: 'Feature',
                            // properties: {
                            //     // dbh: 5,
                            //     title: address.company || address.member.company || address.member.name
                            // },
                            geometry: {
                                type: 'Point',
                                coordinates: [address.longitude, address.latitude]
                            }
                        };
                    }
                })
                .filter(Boolean);

            const visibleAddresses = {
                type: 'FeatureCollection',
                features: []
            };

            visibleAddresses.features = this.visibleAddresses
                .map(address => {
                    if (address.latitude && address.longitude) {
                        let oneLiner = [];

                        if (address.street) {
                            let street = address.street;
                            if (address.zipcode || address.city) street += ',';
                            oneLiner.push(street);
                        }

                        if (address.zipcode) oneLiner.push(address.zipcode);
                        if (address.city) oneLiner.push(address.city);

                        return {
                            type: 'Feature',
                            properties: {
                                // dbh: 5,
                                title: address.company || address.member.company || address.member.name,
                                address: oneLiner.join(' ')
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [address.longitude, address.latitude]
                            }
                        };
                    }
                })
                .filter(Boolean);

            const map = this.$refs.mapbox.map;

            // let pinOutlinedImage = new Image(24,34)
            // pinOutlinedImage.onload = () => map.addImage('custom-marker', pinOutlinedImage)
            // pinOutlinedImage.src = PinOutlined

            // all addresses

            if (map.getSource('addresses')) {
                setTimeout(() => map.getSource('addresses').setData(addresses), delay);
                // map.getSource('addresses').setData(addresses);
            } else {
                let circleOutlinedImage = new Image(10, 10);
                circleOutlinedImage.onload = () => map.addImage('circle-outlined-marker', circleOutlinedImage);
                circleOutlinedImage.src = circleOutlined;

                map.addSource('addresses', {
                    type: 'geojson',
                    data: addresses
                });

                map.addLayer({
                    id: 'addresses',
                    type: 'symbol',
                    source: 'addresses',
                    layout: {
                        'icon-image': 'circle-outlined-marker',
                        'icon-anchor': 'bottom'
                        // get the title name from the source's "title" property
                        // 'text-field': ['get', 'title'],
                        // 'text-font': [
                        //     'Open Sans Semibold',
                        //     'Arial Unicode MS Bold'
                        // ],
                        // 'text-offset': [0, 1.25],
                        // 'text-anchor': 'top',
                    }

                    // type: 'circle',
                    // source: 'addresses',
                    // paint: {
                    //     'circle-color': '#4264fb',
                    //     'circle-opacity': 0,
                    //     'circle-radius': 4,
                    //     'circle-stroke-width': 3,
                    //     'circle-stroke-color': '#000000'
                    // },
                });
            }

            // visible addresses

            if (map.getSource('visible-addresses')) {
                setTimeout(() => map.getSource('visible-addresses').setData(visibleAddresses), delay);
                // map.getSource('visible-addresses').setData(visibleAddresses);
            } else {
                let circleSolidImage = new Image(10, 10);
                circleSolidImage.onload = () => map.addImage('circle-solid-marker', circleSolidImage);
                circleSolidImage.src = circleSolid;

                map.addSource('visible-addresses', {
                    type: 'geojson',
                    data: visibleAddresses
                });

                map.addLayer({
                    id: 'visible-addresses',
                    // type: 'symbol',
                    // source: 'visible-addresses',
                    // layout: {
                    //     'icon-image': 'circle-solid-marker',
                    //     'icon-anchor': 'bottom',
                    //     'icon-allow-overlap': true,
                    //     // get the title name from the source's "title" property
                    //     'text-field': ['get', 'title'],
                    //     'text-font': [
                    //         'Open Sans Semibold',
                    //         'Arial Unicode MS Bold'
                    //     ],
                    //     // 'text-offset': [0, 1.25],
                    //     'text-anchor': 'top',
                    //     'text-allow-overlap': false,
                    // }

                    type: 'circle',
                    source: 'visible-addresses',
                    paint: {
                        'circle-color': '#000000',
                        // 'circle-opacity': 0.4,
                        'circle-radius': 6,
                        'circle-translate': [0, -5],
                        'circle-stroke-width': 2,
                        'circle-stroke-color': '#ffffff'
                    }
                });

                const popup = new Mapbox.Popup({
                    closeButton: false,
                    closeOnClick: false,
                    offset: 14,
                    className: 'v-offset-5'
                });

                map.on('mouseenter', 'visible-addresses', e => {
                    // Change the cursor style as a UI indicator.
                    map.getCanvas().style.cursor = 'pointer';

                    // Copy coordinates array.
                    const coordinates = e.features[0].geometry.coordinates.slice();
                    const title = e.features[0].properties.title;
                    const address = e.features[0].properties.address;

                    const tooltip = `<div class="text-center">
                        <h3>${title}</h3>
                        <nobr>${address}</nobr>
                    </div>`;

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    // Populate the popup and set its coordinates
                    // based on the feature found.
                    popup
                        .setLngLat(coordinates)
                        .setHTML(tooltip)
                        .addTo(map);
                });

                map.on('mouseleave', 'visible-addresses', () => {
                    map.getCanvas().style.cursor = '';
                    popup.remove();
                });
            }
        },
        addressIsVisible(address) {
            return this.visibleAddresses && this.visibleAddresses.map(el => el.id).includes(address.id);
        },
        updateMapBoxCenter(duration = 0) {
            if (!this.$refs.mapbox || !this.$refs.mapbox.map) return;

            let addresses = this.addresses.filter(address => address.latitude && address.longitude);
            if (this.visibleAddresses && this.visibleAddresses.length) {
                addresses = this.visibleAddresses.filter(address => address.latitude && address.longitude);
            }

            if (addresses.length) {
                let bounds = new Mapbox.LngLatBounds();
                addresses.forEach(el => bounds.extend([el.longitude, el.latitude]));
                // bounds.extend(this.center)

                const options = {
                    padding: 20,
                    duration
                    // center: this.center
                };

                // calculate center related offset
                const ne = bounds.getNorthEast();
                const sw = bounds.getSouthWest();

                const offset = {
                    ne: [this.center[0] - ne.lng, this.center[1] - ne.lat],
                    sw: [this.center[0] - sw.lng, this.center[1] - sw.lat]
                };

                bounds.extend([this.center[0] + offset.ne[0], this.center[1] + offset.ne[1]]);
                bounds.extend([this.center[0] + offset.sw[0], this.center[1] + offset.sw[1]]);

                this.$refs.mapbox.map.fitBounds(bounds, options);
            } else {
                this.$refs.mapbox.map.flyTo({
                    center: this.center,
                    essential: true,
                    zoom: 4,
                    duration
                });
            }
        },
        async loaded(event) {
            // const language = 'de'

            let map = event.map;
            // map.setLayoutProperty('country-label', 'text-field', [ 'get', 'name_' + language ]);

            setTimeout(() => (this.showMap = true), 50);

            map.addControl(new MultiTouch());

            this.updateMapBoxCenter();
        }
    }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.map-container
    @apply bg-gray-100 flex shadow
    border-radius: 4px
    // min-height: 160px
    // @screen md
    //     min-height: 320px
    .mgl-map-wrapper
        opacity: 0
        transition: opacity .3s ease
        height: auto
    &.show .mgl-map-wrapper
        opacity: 1
    &::v-deep canvas
        border-radius: 4px

    .mapboxgl-marker
        width: 1.2rem
        color: $blue
        fill: currentColor
        &:after
            content: ''
            position: absolute
            width: 10px
            height: 0px
            bottom: -2px
            left: calc(50% - 5px)
            box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)
    .marker.address
        color: $red
// .dot
//     border: 2px solid $red
//     width: 10px
//     height: 10px
//     border-radius: 50%
//     position: relative
//     left: 4px
//     bottom: -6px
//     &.solid
//         background: $red
</style>
